import { forOwn, isObjectLike } from 'lodash';
const deepFreeze = (object) => {
    if (!isObjectLike(object)) return;
    Object.freeze(object);
    forOwn(object, function (value) {
        if (!isObjectLike(value) || Object.isFrozen(value)) return;
        deepFreeze(value);
    });
    return object;
};
export default deepFreeze;